// @flow

import React from 'react';
import { FilterBreadcrumbs as WithFilterBreadcrumbs } from 'shared_hocs/filters/Breadcrumbs';
import { Breadcrumbs } from 'shared_components/common/breadcrumbs/Breadcrumbs';

type Props = {
  filterDomain: string,
  filters: Object,
  config: Array<string>,
  additionalLinks?: Array<Object>,
  includePageRootLink?: boolean,
  includeMediumInStyle?: boolean,
};

/**
 * FilterBreadcrumbs
 *
 * @param {Props} props
 */
export const FilterBreadcrumbs = ({
  filterDomain,
  filters,
  config,
  additionalLinks = [],
  includePageRootLink = true,
  includeMediumInStyle = false,
}: Props) => {
  return (
    <WithFilterBreadcrumbs
      filterDomain={filterDomain}
      config={config}
      filters={filters}
      includeMediumInStyle={includeMediumInStyle}
      includePageRootLink={includePageRootLink}
    >
      {(links) => <Breadcrumbs links={[...links, ...additionalLinks]} />}
    </WithFilterBreadcrumbs>
  );
};
